// const getStyles= window.getComputedStyle;
// let triggerEl= document.querySelector(".branch-scroller-section");
// let container= document.querySelector(".branch-scroller-container");
// let movingWrapper= document.querySelector(".branch-container-wrapper");
// let branch= document.querySelector(".branch-container");
// let branches= document.querySelectorAll(".branch-container");
// let no_of_branches= document.querySelectorAll(".branch-container").length;;
// let dragger= document.querySelector(".branch-scrollbar-dragger");




// document.addEventListener("DOMContentLoaded", (event) => {
//   gsap.registerPlugin(ScrollTrigger)
//   // gsap code here!
//   function createBranchAnimation(){
//     let aninmationsArr= [];
//     const branchHeight= parseInt(getStyles(branch).height.replace("px",""));
//     container.style.height= `${branchHeight}px`;
//     gsap.to(movingWrapper,{
//       scrollTrigger: {
//         trigger: triggerEl,
//         start: "bottom bottom",
//         end: `+=${branchHeight * (no_of_branches - 1)}`,
//         pin: true,
//         scrub: true,
//         onEnter: ()=>{
//           console.log("Enter");
//           branches.forEach((branch,i)=>{
//             if(i==0)return;
//             gsap.to(dragger,{
//               scrollTrigger: {
//                 trigger: branch,
//                 start: `top bottom-=${container.getBoundingClientRect().bottom}px`,
//                 markers: true,
//                 id: `branch_trigger-${i}`
//               },
//               y: `${(i * ((branchHeight - (2 * parseInt(getComputedStyle(dragger).top))) / no_of_branches)) + 28}`,
//               duration: 0
//             })
//           })
//         },
//         onLeave: ()=>{
//           console.log("Leave");
//           aninmationsArr.forEach(animation=>{
//             animation.scrollTrigger.disable()
//           })
//         },
//         onEnterBack: ()=>{
//           console.log("EnterBack");
//           aninmationsArr.forEach(animation=>{
//             animation.scrollTrigger.enable()
//           })
//         },
//         onLeaveBack: ()=>{
//           console.log("LeaveBack");
//           aninmationsArr.forEach(animation=>{
//             animation.scrollTrigger.kill(true)
//           })
//         }
//       },
//       y: `${-2*branchHeight}`,
//     })

    
//   }
//   createBranchAnimation();
//   document.addEventListener("resize",createBranchAnimation)
// });
const getStyles= window.getComputedStyle;
let trigger= document.querySelector(".branch-scroller-section");
let container= document.querySelector(".branch-scroller-container");
let movingWrapper= document.querySelector(".branch-container-wrapper");
let branch= document.querySelector(".branch-container");
let branches= document.querySelectorAll(".branch-container");

document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger)
  // gsap code here!
  let animation;
  function createBranchAnimation(){
    const branchHeight= parseInt(getStyles(branch).height.replace("px",""));
    container.style.height= `${branchHeight}px`;
    gsap.to(movingWrapper,{
      scrollTrigger: {
        trigger: trigger,
        start: "bottom bottom",
        end: `+=${branchHeight*(branches.length + 0.5)}`,
        snap: (1/branches.length),
        pin: trigger,
        scrub: true
      },
      y: `${-(branches.length - 1)*branchHeight}`,
    })
  }
  createBranchAnimation();
  document.addEventListener("resize",createBranchAnimation)
});